/**
 * Pure helpers for the Console page-view chart (ASB-3567). Kept free of React
 * so tests/components/pageViewTrend.helpers.test.js can cover them directly.
 */

export const RANGE_OPTIONS = [
	{ value: 7, label: "Past 7 Days" },
	{ value: 14, label: "Past 14 Days" },
	{ value: 30, label: "Past 30 Days" },
];

export const DEFAULT_RANGE = 14;

/**
 * The API always returns the 30 complete days ending yesterday in date order;
 * the dropdown only ever narrows that, so take the newest `days` entries.
 */
export function sliceRange(series, days) {
	const count = Math.max(0, Math.min(days, series.length));
	return series.slice(series.length - count);
}

export function subheadingFor(days) {
	return `Page Views & Unique Users (Past ${days} Days, through yesterday)`;
}

// Dates arrive as "YYYY-MM-DD" UTC days. Parse them as UTC so a viewer west of
// Greenwich does not see every bar labelled with the day before.
const utcDate = (iso) => {
	const [year, month, day] = iso.split("-").map(Number);
	return new Date(Date.UTC(year, month - 1, day));
};

export function formatDayLabel(iso) {
	return utcDate(iso).toLocaleDateString("en-US", { month: "short", day: "numeric", timeZone: "UTC" });
}

export function formatDayTitle(iso) {
	return utcDate(iso).toLocaleDateString("en-US", { month: "short", day: "numeric", year: "numeric", timeZone: "UTC" });
}
